import { render } from "./FooterComponents .vue?vue&type=template&id=3e8a6fb1&scoped=true"
import script from "./FooterComponents .vue?vue&type=script&lang=js"
export * from "./FooterComponents .vue?vue&type=script&lang=js"

import "./FooterComponents .vue?vue&type=style&index=0&id=3e8a6fb1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8a6fb1"]])

export default __exports__